import { createStore, applyMiddleware } from 'redux';
import { withExtraArgument } from 'redux-thunk';  // redux-thunk v3 — named export
import axios from 'axios';
import cartReducer from './reducers/cartReducer';

const store = createStore(
  cartReducer,
  applyMiddleware(withExtraArgument(axios))
);

export default store;
